export const dashboardUtilityApps = [
  {
    label: 'Book Management',
    link: '/book-management/home-office',
    right: 'BookManagement',
    icon: 'menu_book',
  },
  {
    label: 'Case Management',
    link: '/case-management',
    right: 'CM',
    icon: 'business_center',
  },
  {
    label: 'Post Transaction',
    link: '/post-trade',
    right: 'PostTrade',
    icon: 'history_edu',
  },
];

export const bmUtilityApps = [
  {
    label: 'Dashboard',
    link: '/dashboard',
    right: 'NewDashboardTab',
    icon: 'dashboard',
  },
  {
    label: 'Case Management',
    link: '/case-management',
    right: 'CM',
    icon: 'business_center',
  },
  {
    label: 'Post Transaction',
    link: '/post-trade',
    right: 'PostTrade',
    icon: 'history_edu',
  },
];

export const ptUtilityApps = [
  {
    label: 'Reports',
    link: '/post-trade/reports',
    icon: 'summarize',
  },
  {
    label: 'Account Grouping',
    link: '/account-grouping',
    right: 'AccountGroup',
    icon: 'dataset_linked',
  },
  {
    label: 'Case Management',
    link: '/case-management',
    right: 'CM',
    icon: 'business_center',
  },
  {
    label: 'Dashboard',
    link: '/dashboard',
    right: 'NewDashboardTab',
    icon: 'dashboard',
  },
  {
    label: 'Book Management',
    link: '/book-management/home-office',
    right: 'BookManagement',
    icon: 'menu_book',
  },
];
